import React from "react";
import {QueryParamProvider} from 'use-query-params';
import {BaseAppProviderProps} from "../types";


export interface ComponentWrapperProps<T extends BaseAppProviderProps>  {
  children: React.ReactNode
  appProvider: (props: T) => JSX.Element
}

export const ComponentWrapper = (props: any) => {
  return (
        <QueryParamProvider>
          <props.appProvider {...props}  >
            {props.children}
          </props.appProvider>
        </QueryParamProvider>
  )
}




